import BaseService from 'config/bridge/BaseService'
import { IFaqResponse } from 'types/IFaq'
import NewRelicUtils from 'config/monitoring/NewRelicUtils'
import { bridgeErrorToString } from 'utils/bridgeErrorToString'

import BridgeService from './bridgeService'

export default class FaqService {
  static async getFaq() {
    try {
      const response = await BaseService.doExecute<IFaqResponse>({
        method: 'GET',
        endpoint: `${process.env.REACT_APP_API_PET}/faq`,
      })

      return response.data
    } catch (error) {
      BridgeService.tacWb({
        name: 'screen_faq_list',
        module: 'pet',
        actions: ['open_faq'],
        params: {
          action_id: 'Perguntas frequentes',
          error: bridgeErrorToString(error),
        },
        isError: true,
      })

      NewRelicUtils.noticeError(error as Error, {})

      console.error('Error fetching FAQ:', error)
      throw error
    }
  }
}
